const { q } = require('../helpers.js');

export const divSummaryVehicle = q('#divSummaryVehicle');
export const divSummaryInsured = q('#divSummaryInsured');
export const divSummaryInsurance = q('#divSummaryInsurance');
export const btnSummaryBack = q('#btnSummaryBack');
export const btnSummaryNext = q('#btnSummaryNext');